(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sync-landing-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sync-dispatch')) {
    customElements.define('sync-dispatch', class extends HTMLElement {
      connectedCallback() {
        this.refresh();
        this.timer = setInterval(() => this.refresh(), 60000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      refresh() {
        const today = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Africa/Johannesburg',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(new Date());

        const part = type => today.find(p => p.type === type).value;

        const date = new Date(Date.UTC(
          Number(part('year')),
          Number(part('month')) - 1,
          Number(part('day')),
          12
        ));

        const excluded = new Set(
          (this.dataset.exclusions || '')
            .split(/[\s,]+/)
            .filter(Boolean)
        );

        const limit = Math.max(
          2,
          Math.min(5, Number(this.dataset.days) || 5)
        );

        let count = 0;

        while (count < limit) {
          date.setUTCDate(date.getUTCDate() + 1);

          const weekday = date.getUTCDay();
          const isoDate = date.toISOString().slice(0, 10);

          if (
            weekday !== 0 &&
            weekday !== 6 &&
            !excluded.has(isoDate)
          ) {
            count++;
          }
        }

        const time = this.querySelector('time');
        time.dateTime = date.toISOString().slice(0, 10);
        time.textContent = new Intl.DateTimeFormat('en-ZA', {
          timeZone: 'UTC',
          weekday: 'short',
          day: 'numeric',
          month: 'short'
        }).format(date);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sync-product-tabs"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sync-product-tabs')) {
  customElements.define('sync-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.questions = [...this.querySelectorAll('.spt__question')];
      this.querySelector('[role="tablist"]').hidden = false;
      this.questions.forEach(button => this.expand(button, false));
      this.activate(this.dataset.default || 'why');
      this.setAttribute('data-ready', '');
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-tab]');
        if (tab && this.contains(tab)) this.activate(tab.dataset.tab);
        const question = event.target.closest('.spt__question');
        if (question && this.contains(question)) this.expand(question, question.getAttribute('aria-expanded') !== 'true');
      }, options);
      this.addEventListener('keydown', event => {
        const current = event.target.closest('[data-tab]');
        if (!current) return;
        let index = this.tabs.indexOf(current);
        if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(this.tabs[index].dataset.tab);
        this.tabs[index].focus({ preventScroll: true });
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const block = event.target.closest('[data-editor-panel]');
        if (!block || !this.contains(block)) return;
        this.activate(block.dataset.editorPanel);
        const question = block.querySelector('.spt__question');
        if (question) this.expand(question, true);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    activate(key) {
      if (!this.tabs.some(tab => tab.dataset.tab === key)) key = 'why';
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== key; });
    }
    expand(button, open) {
      if (open) this.questions.forEach(other => { if (other !== button) this.expand(other, false); });
      button.setAttribute('aria-expanded', String(open));
      const answer = this.querySelector('[id="' + button.getAttribute('aria-controls') + '"]');
      if (answer) answer.hidden = !open;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
